import { useEffect } from 'react';
import './App.css';
import About from './components/about/About';
import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer';
import Header from './components/Header/Header';
import Home from './components/Home/Home'
import Qualification from './components/Qualification/Qualification';
import Scrollup from './components/Scroolup/Scrollup';
import Services from './components/services/Services';
import Skills from './components/skills/Skills';
import Work from './components/work/Work';
import Aos from 'aos'
import "aos/dist/aos.css"

function App() {
  useEffect(()=> {
    Aos.init({duration : 1500})
  },[])
  return (
    <>
      <Header />
      <main className="main">
        <Home />
        <About />
        <Skills />
        <Services />
        {/* <Qualification /> */}
        <Work/>
        <Contact />
      </main>
      <Footer />
      <Scrollup />
    </>

  );
}

export default App;
